<template>
  <div class="product-card-container">
    <div v-if="title" class="section-header">
      <h2 
        class="section-title" 
        :class="{ 'clickable-title': isAllProducts }"
        @click="isAllProducts ? goToProductList() : null"
      >{{ title }}</h2>
      <div class="title-decoration">
        <span class="dot"></span>
        <span class="line"></span>
        <span class="dot"></span>
      </div>
    </div>
    <el-row :gutter="20" v-if="mode !== 'sidebar'">
      <el-col :span="4" v-for="item in currentDate" :key="item.productId" >
        <div @click="goToProductDetail(item.productId)"> 
        
        <el-card :body-style="{ padding: '0px' }" shadow="hover" class="product-card" >
         
          <!-- 商品图片 -->
          <div class="product-image">
            <img :src="item.primaryImageUrl || 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png'" alt="商品图片" class="image">
          </div>
          
          <!-- 商品信息 -->
          <div class="product-info">
            <!-- 商品名称 -->
            <div class="product-name">{{ item.productName }}</div>
            
            <!-- 价格和销量行 -->
            <div class="product-bottom">
              <span class="price">¥{{ item.price }}</span>
              <span class="sales">{{ formatSalesCount(item.salesCount) }}人付款</span>
            </div>
          </div>
        </el-card>
        </div>
      </el-col>
    </el-row>

    <!-- 侧边栏模式 -->
    <div class="sidebar-list" v-else>
      <div 
        class="sidebar-item" 
        v-for="(item, index) in currentDate" 
        :key="item.productId"
        @click="goToProductDetail(item.productId)"
      >
        <div class="rank-badge" :class="'rank-' + (index + 1)">{{ index + 1 }}</div>
        <div class="item-img">
          <img :src="item.primaryImageUrl" alt="">
        </div>
        <div class="item-info">
          <div class="item-name">{{ item.productName }}</div>
          <div class="item-bottom">
            <span class="item-price">¥{{ item.price }}</span>
            <span class="item-sales">{{ formatSalesCount(item.salesCount) }}人付款</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 分页 -->
    <div class="pagination-container" v-if="showPagination">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    
    <!-- 查看全部商品按钮 -->
    <div class="view-all-container" v-if="isAllProducts && !showPagination">
      <el-button type="primary" plain round @click="goToProductList">查看更多商品 <i class="el-icon-arrow-right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { getProductCardList, getProductsBySort, searchProducts, getProductsByCategory } from "@/apis/ProductCard";

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    categoryId: {
      type: [String, Number],
      default: ''
    },
    sortField: {
      type: String,
      default: '' // 'create_time' or 'sales' or 'price'
    },
    sortOrder: {
      type: String,
      default: 'desc'
    },
    pageSize: {
      type: Number,
      default: 12
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    isAllProducts: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'grid' // 'grid' or 'sidebar'
    }
  },
  data() {
    return {
      currentDate: [],
      total: 0,
      currentPage: 1
    };
  },
  watch: {
    // 监听关键词变化，重置页码并重新加载数据
    keyword() {
      this.currentPage = 1;
      this.getProductCardList();
    },
    // 监听分类ID变化
    categoryId() {
      this.currentPage = 1;
      this.getProductCardList();
    },
    // 监听排序变化
    sortField() {
      this.currentPage = 1;
      this.getProductCardList();
    },
    sortOrder() {
      this.currentPage = 1;
      this.getProductCardList();
    }
  },
  mounted() {
    this.getProductCardList();
  },
  methods: {
    getProductCardList() {
      // 1. 如果有分类ID，优先使用分类接口（支持搜索和排序）
      if (this.categoryId) {
        getProductsByCategory(this.categoryId, this.currentPage, this.pageSize, this.keyword, this.sortField, this.sortOrder).then(res => {
          this.handleResponse(res);
        }).catch(err => {
          console.error("获取分类商品失败", err);
        });
      } 
      // 2. 如果只有搜索关键词，使用搜索接口
      else if (this.keyword) {
        searchProducts(this.keyword, this.currentPage, this.pageSize).then(res => {
          this.handleResponse(res);
        }).catch(err => {
          console.error("搜索商品失败", err);
        });
      } 
      // 3. 如果指定了排序字段，使用排序API
      else if (this.sortField) {
        getProductsBySort(this.sortField, this.sortOrder, this.currentPage, this.pageSize).then(res => {
          this.handleResponse(res);
        }).catch(err => {
          console.error("获取排序商品列表失败", err);
        });
      } 
      // 4. 默认列表
      else {
        getProductCardList(this.currentPage, this.pageSize).then(res => {
          this.handleResponse(res);
        }).catch(err => {
          console.error("获取商品列表失败", err);
        });
      }
    },
    
    handleResponse(res) {
      console.log("获取商品列表成功", res);
      if (res.data && res.data.records) {
        this.currentDate = res.data.records;
        this.total = res.data.total;
      }
    },
    
    // 跳转到商品详情页
    goToProductDetail(id) {
      console.log("跳转到商品详情页，商品ID:", id);
      if (!id) {
        console.error("商品ID为空，无法跳转");
        this.$message.error("商品ID无效，无法查看详情");
        return;
      }
      console.log("准备跳转，路径:", `/product/${id}`);
      this.$router.push(`/product/${id}`).then(() => {
        console.log("跳转成功");
      }).catch(err => {
        console.error("跳转失败:", err);
      });
    },
    
    // 跳转到商品列表页
    goToProductList() {
      this.$router.push('/products');
    },
    // 格式化销量显示
    formatSalesCount(count) {
      if (!count && count !== 0) return '0';
      if (count >= 100) {
        return count + '+';
      }
      return count;
    },
    
    // 分页处理
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getProductCardList();
    }
  }
};
</script>

<style lang="less" scoped>
.product-card-container {
  width: 100%;
  margin: 0;
  padding: 28px 0 40px;
}

.section-header {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
  
  .section-title {
    font-size: 28px;
    font-weight: 800;
    color: #333;
    margin-bottom: 10px;
    letter-spacing: 2px;
    background: linear-gradient(90deg, #6c7bff 0%, #00d4ff 50%, #ff7bd5 100%);
    -webkit-background-clip: text;
    color: transparent;
    display: inline-block;
    
    &.clickable-title {
      cursor: pointer;
      transition: opacity 0.3s ease;
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
  
  .title-decoration {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    
    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #6c7bff;
    }
    
    .line {
      width: 40px;
      height: 2px;
      background: linear-gradient(90deg, transparent, #6c7bff, transparent);
    }
  }
}

.product-card-container /deep/ .el-row {
  margin-left: -10px;
  margin-right: -10px;
}

.product-card-container /deep/ .el-col {
  padding-left: 10px;
  padding-right: 10px;
}

.view-all-container {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.product-card {
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  border-radius: 12px;
  border: 1px solid #e2e7ff;
  position: relative;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 26px rgba(108, 123, 255, 0.2);
    border-color: #cfd7ff;
  }
}

.product-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #6c7bff 0%, #00d4ff 50%, #ff7bd5 100%);
}

.product-image {
  position: relative;
  overflow: hidden;
  border: 1px solid #e3e8ff;
  line-height: 0; // 消除图片底部的微小间隙
  
  .image {
    display: block; // 确保图片紧贴边框
    width: 100%;
    height: 200px;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .product-card:hover .image {
    transform: scale(1.05);
  }
}

.product-info {
  padding: 14px;
}

.product-name {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #333;
}

.product-bottom {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 8px;
}

.price {
  font-size: 18px;
  font-weight: bold;
  background: linear-gradient(90deg, #6c7bff 0%, #00d4ff 60%, #ff7bd5 100%);
  -webkit-background-clip: text;
  color: transparent;
}

.sales {
  font-size: 12px;
  color: #999;
}

.pagination-container {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

/* 侧边栏列表样式 */
.sidebar-list {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .sidebar-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background: #fff;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #f0f2ff;

    &:hover {
      transform: translateX(3px);
      box-shadow: 0 4px 12px rgba(108, 123, 255, 0.1);
      border-color: #6c7bff;
    }

    .rank-badge {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 11px;
      font-weight: bold;
      background: #f0f2ff;
      color: #7c81a8;

      &.rank-1 { background: #ff4d4f; color: #fff; }
      &.rank-2 { background: #ffa940; color: #fff; }
      &.rank-3 { background: #ffec3d; color: #333; }
    }

    .item-img {
      width: 50px;
      height: 50px;
      flex-shrink: 0;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #eee;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .item-info {
      flex: 1;
      overflow: hidden;
      min-width: 0; // 允许文本截断

      .item-name {
        font-size: 13px;
        color: #333;
        font-weight: 500;
        margin-bottom: 3px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item-bottom {
        display: flex;
        align-items: baseline;
        gap: 6px;
      }

      .item-price {
        font-size: 14px;
        color: #6c7bff;
        font-weight: bold;
      }

      .item-sales {
        font-size: 10px;
        color: #999;
        white-space: nowrap;
      }
    }
  }
}
</style>
